import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { getObligationSummary } from "@/lib/companyObligations";

export function ObligationNavBadge() {
  const { can, user } = useAuth();
  const userId = user?.id ?? null;
  const allowed = can("company_obligation", "read") || can("obligation_task", "read");
  const [result, setResult] = useState<{ userId: string | null; count: number } | null>(null);
  const count = result?.userId === userId ? result.count : 0;
  useEffect(() => {
    if (!allowed) return;
    let controller: AbortController | null = null;
    const refresh = () => {
      controller?.abort(); controller = new AbortController();
      const current = controller;
      void getObligationSummary(current.signal).then((summary) => { if (!current.signal.aborted) setResult({ userId, count: summary.expired + summary.my_open_tasks }); }).catch(() => { /* The badge must not block navigation on a transient failure. */ });
    };
    refresh(); window.addEventListener("obligations-changed", refresh); window.addEventListener("focus", refresh);
    return () => { controller?.abort(); window.removeEventListener("obligations-changed", refresh); window.removeEventListener("focus", refresh); };
  }, [allowed, userId]);
  return allowed && count > 0 ? <span className="ml-2 rounded-full bg-[var(--color-status-bad-bg)] px-2 py-0.5 text-xs text-[var(--color-status-bad-fg)]" aria-label={`${count} isteklih obveza i mojih otvorenih zadataka`}>{count}</span> : null;
}
